import { useEffect } from "react";
import { CreateOrderViewModel } from "../../viewmodels/orders/CreateOrderViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import CreateNewOrderForm from "../../components/forms/orders/CreateNewOrderForm";
import { useNavigate } from "react-router-dom";
import {
  USER_DEPARTMENT_CODE,
  USER_TYPE_CODE,
} from "../../shared/userReferenceCodes";

function CreateOrder(props) {
  const { logout, addSnackbar, user_type } = props;
  const {
    customers,
    getCustomersForDropdown,
    getMyProducts,
    resolveProductPrice,
    loading,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    createOrderApiCall,
    employeeOptions,
    getUsersForDropdown,
    navigateDestination,
  } = CreateOrderViewModel(logout, addSnackbar);

  const navigate = useNavigate();

  useEffect(() => {
    getUsersForDropdown(
      [USER_TYPE_CODE.REGULAR, USER_TYPE_CODE.SUPERVISOR],
      [USER_DEPARTMENT_CODE.ALL, USER_DEPARTMENT_CODE.ORDERS],
    );
    getCustomersForDropdown();
  }, []);

  useEffect(() => {
    if (navigateDestination !== null) {
      navigate(navigateDestination);
    }
  }, [navigateDestination]);

  return (
    <div className="qatrace-screen qatrace-module-page">
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Create Order
            </h1>
          </div>
          <div className="mt-5">
            <CreateNewOrderForm
              customers={customers}
              getMyProducts={getMyProducts}
              resolveProductPrice={resolveProductPrice}
              isEdit={false}
              loading={loading}
              setEmptyModelOpen={setEmptyModelOpen}
              showErrorModal={showErrorModal}
              createOrderApiCall={createOrderApiCall}
              setSlideOver={setSlideOver}
              employeeOptions={employeeOptions}
              user_type={user_type}
            />
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { user_type: state.auth.user_type };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateOrder),
);
